import React from "react";
import moment from "moment";

const GraceBanner = ({ hasAccessUntil, gracePeriod }) => {
  const now = moment();
  const endDate = moment(hasAccessUntil);
  const grace = moment(hasAccessUntil).subtract(gracePeriod, "days");
  const isFullyExpired = endDate.isBefore(now);
  const isGraceExpired = endDate.isAfter(now) && grace.isBefore(now);

  if (!isGraceExpired) return null;

  return (
    <div className="flex justify-center items-center w-full">
      {isGraceExpired && (
        <div className="rounded-md bg-blue-200 p-4 border border-blue-500">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-blue-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <div className="mt-2 text-sm leading-5 text-blue-700">
                You have <b>{endDate.toNow("dd")}</b> until your account is put
                on hold and you will be required to repurchase to activate your
                account.
              </div>
            </div>
          </div>
        </div>
      )}

      {isFullyExpired && (
        <div className="rounded-md bg-red-200 p-4 w-full">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-red-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3 w-full">
              <h3 className="text-sm leading-5 font-medium text-red-800">
                Your subscription has been expired!
              </h3>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GraceBanner;
